define('home/collections/TopicCollection',[
    'underscore',
    'backbone',

    'home/models/Topic',
    'core/UniqueModel',

    'core/api',
    'core/strings',
], function (
    _,
    Backbone,

    Topic,
    UniqueModel,

    api,
    strings
) {
    'use strict';

    var gettext = strings.get;

    var TopicCollection = Backbone.Collection.extend({
        model: UniqueModel.boundModel(Topic),

        initialize: function (_models, options) {
            if (options && options.thread)
                this.thread = options.thread;
        },

        /**
         * Returns the intersection of topics in this collection and categories
         * on the channel for this collection's thread, case insensitive.
         * Technically this can return more than 1, ex: during editing a user
         * may input more than 1 category as a topic. Validation should prevent
         * a thread from being saved with more or less than 1 returned category.
         */
        getCategoryTopics: function () {
            var channel = this.thread.forum.channel;
            var categories = channel.getCategories();

            if (!categories)
                return [];

            categories = categories && _.keys(categories);
            return this.filter(function (topic) {
                var lowerDisplayName = topic.get('displayName').toLowerCase();

                return _.find(categories, function (category) {
                    return Topic.cleanTopicName(category).toLowerCase() === lowerDisplayName;
                });
            });
        },

        isValid: function () {
            var error = this.validationError = this.validate() || null;
            if (!error)
                return true;

            this.trigger('invalid', this, error, { validationError: error });
            return false;
        },

        validate: function () {
            // First check for topics invalid on their own
            var invalidModel = this.find(function (topic) {
                return !topic.isValid();
            });

            if (invalidModel)
                return invalidModel.validationError;

            // No restrictions on topic collections not bound to a thread
            if (!this.thread)
                return;

            // Check max length. Only check non-hidden topics (those editable by and
            // visible to the user).
            var countsByHidden = this.countBy(function (topic) {
                return topic.get('hidden') ? 'hidden' : 'visible';
            });
            if (countsByHidden.visible > TopicCollection.MAX_LENGTH) {
                return {
                    attrName: 'topics',
                    message: strings.interpolate(gettext('You may not have more than %(num)s topics'), { num: TopicCollection.MAX_LENGTH }),
                };
            }

            var channel = this.thread.forum.channel;
            var categories = channel && channel.getCategories();
            if (categories) {
                var chosenCategories = this.getCategoryTopics();

                if (chosenCategories.length < 1) {
                    return {
                        attrName: 'category',
                        message: gettext('You must choose a category'),
                    };
                }

                var collidesWithCategory = _.any(
                    chosenCategories,
                    function (category) { return !category.get('hidden'); }
                );
                if (collidesWithCategory) {
                    return {
                        attrName: 'topics',
                        message: gettext('You may not enter a category as a topic'),
                    };
                }
            }
        },

        _syncTopicsOnThread: function (topics, method) {
            var options = {
                url: this.urls[method],
                type: 'POST',
                processData: true,
                emulateHTTP: true,
                data: {
                    thread: this.thread.id,
                    topics: _.map(topics, function (item) {
                        return item.get('displayName');
                    }),
                },
            };

            return Backbone.sync(method, this, options);
        },

        urls: {
            'addTopicsToThread': api.getURL('timelines/curation/addTopicsToThread'),
            'removeTopicsFromThread': api.getURL('timelines/curation/removeTopicsFromThread'),
        },

        save: function () {
            if (!this.thread || !this.isValid())
                return;

            var syncedTopics = this.thread.topics.models;
            var addedTopics = _.difference(this.models, syncedTopics);
            var removedTopics = _.difference(syncedTopics, this.models);
            var thread = this.thread;

            if (addedTopics.length) {
                this._syncTopicsOnThread(addedTopics, 'addTopicsToThread').then(function (response) {
                    if (response.response) {
                        // Endpoint returned topic details: consistent casing for display names and
                        // identifiers. Add these full topics to the thread's topic collection.
                        thread.topics.add(_.map(response.response, function (attrs) {
                            return new UniqueModel(Topic, attrs);
                        }));
                    }
                });
            }

            if (removedTopics.length) {
                this._syncTopicsOnThread(removedTopics, 'removeTopicsFromThread').then(function () {
                    thread.topics.remove(removedTopics);
                });
            }
        },

        parse: function (response) {
            return response.response;
        },
    }, {
        MAX_LENGTH: 5,
    });

    return TopicCollection;
});

